import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-20 md:py-24 px-4 bg-white" data-id="element-289">
      <div className="max-w-3xl mx-auto text-center" data-id="element-290">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-291">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-heading font-bold text-text-heading mb-12" data-id="element-292">
            LA VERDAD QUE NADIE TE DICE
          </motion.h2>

          <div className="space-y-10 text-lg md:text-xl text-text-body" data-id="element-293">
            <motion.p variants={itemVariants} data-id="element-294">
              El problema no es que seas mala madre o mal padre.
              <br data-id="element-295" />
              <span className="font-bold text-secondary-coral block mt-2" data-id="element-296">
                El problema es que nadie te enseñó cómo funciona el sistema
                nervioso de tu hijo en la mesa.
              </span>
            </motion.p>

            <motion.p variants={itemVariants} className="font-bold text-text-heading text-xl md:text-2xl" data-id="element-297">
              El 80% de las crisis de alimentación en niños selectivos son
              respuestas neurológicas preventibles.
            </motion.p>

            <motion.p variants={itemVariants} data-id="element-298">
              No son caprichos. No son mala educación.
              <br data-id="element-299" />
              <span className="font-bold text-secondary-coral block mt-2" data-id="element-300">
                Son respuestas de un cerebro que percibe el alimento nuevo como
                una amenaza real.
              </span>
            </motion.p>

            <motion.p variants={itemVariants} className="font-bold text-text-heading p-6 bg-warm-cream rounded-xl border border-secondary-coral-light/20 shadow-sm" data-id="element-301">
              Cuando le decís "probá un bocadito", su amígdala activa la misma
              alarma que nosotros tendríamos si hubiera una araña en el plato.
            </motion.p>

            <motion.p variants={itemVariants} data-id="element-302">
              La presión no resuelve el problema. Lo profundiza.
              <br data-id="element-303" />
              La tablet no resuelve el problema. Lo patea para adelante.
              <br data-id="element-304" />
              El "ya va a comer cuando tenga hambre" no resuelve el problema. Lo
              ignora.
            </motion.p>

            <motion.p variants={itemVariants} className="text-xl md:text-2xl" data-id="element-305">
              La solución no es insistir más.
              <br data-id="element-306" />
              <span className="font-bold text-[#3D7A5E] block mt-2" data-id="element-307">
                La solución es entender cómo funciona su cerebro y crear las
                condiciones para que diga SÍ solo.
              </span>
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}